

function animateLogos() {
  $('.block-animated-logos').each(function(index) {
    animateLogo(this);
  });
}

function animateLogo(logo) {
  var $this = $(logo);

  var $logoBlock  = $this.find(".block-logo");
  var $logoImage  = $this.find(".block-logo").find("img");

  TweenMax.set($logoBlock, {opacity: 0, y: 20});
  TweenMax.set($logoImage, {opacity: 0});

  var logosTL  = new TimelineLite({paused: true});

  logosTL.staggerTo($logoBlock, 1, {y: 0, opacity: 1, ease: Power4.easeOut}, 0.2)
         .staggerTo($logoImage, 0.5, { opacity: 1, ease: Power4.easeOut}, 0.2, 0.6);

  var scene = new ScrollMagic.Scene({
    triggerElement: logo,
    triggerHook: 0.7,
    offset: 0
  })
  .on('enter', function (event) {
    logosTL.play().timeScale(1);
  })
  .on('leave', function (event) {
    logosTL.reverse().timeScale(1.5);
  })
  .addTo(controller);
}